import { PRODUCTS as products } from 'common/constants'
import { productIdFromEdgeProduct } from 'common/api/v1/helpers'
import { EdgeProduct } from 'common/api/v1/types'

export const IS_PROD = process.env.NODE_ENV === 'production'
export const EDGE_PRODUCT = productIdFromEdgeProduct(
  (import.meta.env.VITE_EDGE_PRODUCT as EdgeProduct) || EdgeProduct.edge,
)
export const IS_CONNECT_IT = EDGE_PRODUCT === products.connectIt.id

export const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN
export const MIXPANEL_TOKEN = (window as any).Cypress ? undefined : import.meta.env.VITE_MIXPANEL_TOKEN
